<script>
	import { onMount } from 'svelte'

  let canvas,
      width,
      height,
      score = 0,
      combo = 0

  class Tile {
    
    constructor(lane) {
      this.lane = lane
      this.w = width / 4 - 2
      this.h = (height / 4) / 4 / 2
      this.x = 1 + lane * width / 4
      this.y = -2 * this.h
      this.speed = 10
    }
    
    show(ctx) {
      ctx.fillStyle = 'rgba(255,255,255,0.5)'
      ctx.fillRect(this.x, this.y, this.w, this.h);
    }
  
    move() {
      this.y += this.speed
    }
  
    arrive() {
      return this.y > height
    }
  }

  onMount(() => {
    width = window.innerWidth
    height = window.innerHeight

    canvas.width = width
    canvas.height = height

    const ctx = canvas.getContext('2d')
    
    const tiles = []
    tiles.push(new Tile( Math.floor(Math.random() * 4) ))

    // Animating
    let frame = requestAnimationFrame(loop)

    function loop(t) {
      frame = requestAnimationFrame(loop)

      draw(ctx, tiles)

      return () => cancelAnimationFrame(frame)
    }

    // Alterntaive way to animate
    // setInterval(() => {
    //   draw(ctx, tiles)
    // }, 20)
  })

  function draw(ctx, tiles) {
    ctx.clearRect(0,0, width, height)
    
    drawBackground(ctx)
    drawLines(ctx)
   
    if (tiles[tiles.length - 1].arrive()) {
      combo += 1
      score += (1 * combo)
      tiles.push(new Tile( Math.floor(Math.random() * 4) ))
    }

    for (const tile of tiles) {
      tile.show(ctx)
      tile.move()
    }

    drawSegmentBox(ctx)
    drawScore(ctx, score)
    drawCombo(ctx, combo)
  }

  function drawScore(ctx, score = 0) {
    ctx.font = `${5 * width / 100}px sans-serif`
    ctx.fillText(`Score: ${score}`, 10, 15)
  }

  function drawCombo(ctx, combo = 0) {
    const num = new Number(combo).toString().length
    ctx.font = `${15 * width / 100}px sans-serif`
    ctx.fillText(combo, ((50 - (num * 4)) * width / 100), width / 4)
  }

  function drawSegmentBox(ctx) {
    ctx.fillStyle = 'rgba(255,255,255,1'
    ctx.fillRect(0, 90 * height / 100, width / 4, 90 * height / 100)

    ctx.fillStyle = 'rgba(255,150,150,1'
    ctx.fillRect((width / 4), 90 * height / 100, width / 4, 90 * height / 100)

    ctx.fillStyle = 'rgba(255,150,150,1'
    ctx.fillRect((width / 4) * 2, 90 * height / 100, width / 4, 90 * height / 100)

    ctx.fillStyle = 'rgba(255,255,255,1'
    ctx.fillRect((width / 4) * 3, 90 * height / 100, width / 4, 90 * height / 100)
  }

  function drawBackground(ctx) {
    // Create gradient color
    const bgGradient = ctx.createLinearGradient(0, 0, 0, 570)
    bgGradient.addColorStop(0, '#155799')
    bgGradient.addColorStop(1, '#159957')
    
    // Fill background with gradient color
    ctx.fillStyle = bgGradient
    ctx.fillRect(0, 0, width, height)
  }

  function drawLines(ctx) {
    // Create 3 line to divide lane
    for (const i of Array(4).keys()) {
        ctx.beginPath()
        ctx.moveTo((width / 4) * (i + 1), 0)
        ctx.lineTo((width / 4) * (i + 1), height)
        ctx.strokeStyle = '#fff'
        ctx.stroke()
    }

    // Create 1 line as bottom segment
    ctx.beginPath()
    ctx.moveTo(0, 90 * height / 100)
    ctx.lineTo(width, 90 * height / 100)
    ctx.strokeStyle = '#fff'
    ctx.stroke()
  }
</script>

<canvas bind:this={canvas}></canvas>